module.exports = __webpack_public_path__ + "img/slim_cleanstation13.d1762af8.jpg";